"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9342],{

/***/ 9342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ sliding_card_grid_base_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./segments/desktop/core-components/carousel/carousel.js + 3 modules
var carousel = __webpack_require__(28391);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./services/bigbrain-service.js + 1 modules
var bigbrain_service = __webpack_require__(95470);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/sliding-card-grid/components/sliding-card-grid-base/prev-carousel-arrow.js



var PrevCarouselArrow = function(param) {
    var isDisabled = param.isDisabled, _color = param.color, color = _color === void 0 ? colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "23",
        height: "24",
        viewBox: "0 0 23 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Previous item"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.939341 10.9393C0.353554 11.5251 0.353554 12.4749 0.93934 13.0607L10.4853 22.6066C11.0711 23.1924 12.0208 23.1924 12.6066 22.6066C13.1924 22.0208 13.1924 21.0711 12.6066 20.4853L4.12132 12L12.6066 3.51472C13.1924 2.92893 13.1924 1.97918 12.6066 1.3934C12.0208 0.807609 11.0711 0.807609 10.4853 1.3934L0.939341 10.9393ZM23 10.5L2 10.5L2 13.5L23 13.5L23 10.5Z",
                fill: isDisabled ? colors/* default.gainsboro */.Z.gainsboro : color
            })
        ]
    });
};
/* harmony default export */ var prev_carousel_arrow = (PrevCarouselArrow);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/sliding-card-grid/components/sliding-card-grid-base/next-carousel-arrow.js



var NextCarouselArrow = function(param) {
    var isDisabled = param.isDisabled, _color = param.color, color = _color === void 0 ? colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "23",
        height: "24",
        viewBox: "0 0 23 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Next item"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.0607 10.9393C22.6464 11.5251 22.6464 12.4749 22.0607 13.0607L12.5147 22.6066C11.9289 23.1924 10.9792 23.1924 10.3934 22.6066C9.80761 22.0208 9.80761 21.0711 10.3934 20.4853L18.8787 12L10.3934 3.51472C9.80761 2.92893 9.80761 1.97918 10.3934 1.3934C10.9792 0.807609 11.9289 0.807609 12.5147 1.3934L22.0607 10.9393ZM-2.93491e-07 10.5L21 10.5L21 13.5L2.93491e-07 13.5L-2.93491e-07 10.5Z",
                fill: isDisabled ? colors/* default.gainsboro */.Z.gainsboro : color
            })
        ]
    });
};
/* harmony default export */ var next_carousel_arrow = (NextCarouselArrow);

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/components/basic-header/constants.js
var constants = __webpack_require__(72428);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/sliding-card-grid/components/sliding-card-grid-base/sliding-card-grid-base-component.scss.js




var CARDS_MARGIN = "24px";
var HEADER_CONTENT_HORIZONTAL_PADDING = "".concat(constants/* default.HEADER_CONTENT_HORIZONTAL_PADDING */.Z.HEADER_CONTENT_HORIZONTAL_PADDING, "px");
var FULL_SCREEN_LEFT_PADDING = "24px";
var ARROW_WIDTH = "23px";
var ARROW_MARGIN = "16px";
var DEFAULT_CARD_BORDER_RADIUS = "8px";
var DEFAULT_CARD_IMAGE_BORDER_RADIUS = "0, 0, 8px, 8px";
var StyledSlidingCardGridBaseComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1r2yr9x0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;display:flex;flex-direction:column;padding:", function(param) {
    var desktopVerticalPadding = param.desktopVerticalPadding, desktopHorizontalPadding = param.desktopHorizontalPadding;
    return "".concat(desktopVerticalPadding || "0", " ").concat(desktopHorizontalPadding ? "".concat(desktopHorizontalPadding, " !important") : "0");
}, ";@media (max-width:", vp_sizes/* MAX_DESKTOP_GRID_WIDTH */.sk, "px){padding:", function(param) {
    var desktopVerticalPadding = param.desktopVerticalPadding, desktopHorizontalPaddingSmallScreens = param.desktopHorizontalPaddingSmallScreens;
    return "".concat(desktopVerticalPadding || "0", " ").concat(desktopHorizontalPaddingSmallScreens ? "".concat(desktopHorizontalPaddingSmallScreens, " !important") : "0");
}, ";}&.with-title{.carousel .slick-slider .slick-list .slick-track{padding:0;}}&.full-carousel-width{max-width:", vp_sizes/* FULL_HD_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.KI, "px;padding-left:calc(\n      max(min(100vw,", vp_sizes/* FULL_HD_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.KI, "px) - ", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px,0px) / 2 +\n      ", HEADER_CONTENT_HORIZONTAL_PADDING, "    );}&.full-screen{max-width:", vp_sizes/* FULL_HD_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.KI, "px;padding-right:0;padding-left:24px;.carousel-arrow-wrapper{&.next{left:calc(50% - ", FULL_SCREEN_LEFT_PADDING, ");}&.prev{left:calc(50% - ", FULL_SCREEN_LEFT_PADDING, " - ", ARROW_WIDTH, ");}}}&.infinite-mode{.carousel .slick-slider .slick-list .slick-track{justify-content:flex-end;}}&.edge-arrows{position:relative;.carousel-arrows-edge-group{position:absolute;right:32px;top:", function(param) {
    var arrowsTopOffset = param.arrowsTopOffset;
    return arrowsTopOffset || 0;
}, ";gap:16px;display:flex;flex-direction:row;z-index:2;background:transparent;border:none;box-shadow:none;.carousel-arrow-wrapper.next,.carousel-arrow-wrapper.prev{position:static;width:62px;height:62px;top:auto;left:auto;right:auto;transform:none;box-shadow:none;background:transparent;border:none;}}}.carousel{.slick-slider{.slick-list{.slick-track{display:flex;padding-bottom:80px;padding-top:0;.slick-slide{height:auto;> div:first-child{height:100%;}}.carousel-item{height:100%;.card-grid-link{.grid-paragraph-with-image{cursor:grab;border-radius:", function(param) {
    var cardBorderRadius = param.cardBorderRadius;
    return cardBorderRadius || DEFAULT_CARD_BORDER_RADIUS;
}, ";margin-right:", CARDS_MARGIN, ";min-height:100%;width:100%;.grid-paragraph-wrapper{display:flex;width:100%;.full-paragraph{.button-wrapper{min-height:56px;margin-top:0;.button{display:flex;align-items:flex-end;}}}}.grid-image-wrapper{max-width:", function(param) {
    var cardImageSize = param.cardImageSize;
    return cardImageSize;
}, ";min-width:", function(param) {
    var cardImageSize = param.cardImageSize;
    return cardImageSize;
}, ";img{border-radius:", function(param) {
    var cardImageRadius = param.cardImageRadius;
    return cardImageRadius || DEFAULT_CARD_IMAGE_BORDER_RADIUS;
}, ";}}}}}}}}}&.disable-hover-effect{cursor:initial;.carousel{.slick-slider{.slick-list{.slick-track{.slick-slide:last-child{.grid-paragraph-with-image{margin-right:0;}}.carousel-item{.card-grid-link{.grid-paragraph-with-image{cursor:initial;}}}}}}}}.carousel .carousel-arrow-wrapper{top:auto;position:absolute;bottom:0;z-index:", z_index/* TOP_LAYER */.nA, ";height:fit-content;width:fit-content;&.next{left:50%;margin-left:", ARROW_MARGIN, ";&::before{content:none;}}&.prev{left:calc(50% - ", ARROW_WIDTH, ");margin-left:-", ARROW_MARGIN, ";&::before{content:none;}}}.carousel-title-component .core-title-container .core-title{font-size:6rem;font-weight:200;line-height:1.1;}@media (max-width:", vp_sizes/* MAX_DESKTOP_GRID_WIDTH */.sk, "px){.carousel-title-component .core-title-container .core-title{font-size:5rem;}}");

// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/sliding-card-grid/components/sliding-card-grid-base/sliding-card/sliding-card-component.scss.js


var StyledSlidingCardComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ed3jp1x0"
})("	position:relative;height:100%;&.side-by-side-image{.grid-paragraph-with-image{align-items:center;flex-direction:", function(param) {
    var reverseImageAndText = param.reverseImageAndText;
    return reverseImageAndText ? "row-reverse" : "row";
}, ";.grid-paragraph-wrapper{height:fit-content;}.grid-image-wrapper{flex:1;padding:16px;img{object-fit:contain;}}}}.grid-paragraph-with-image{transition:background-color 0.3s ease-in-out;}&:not(.side-by-side-image) .card-grid-link .grid-paragraph-with-image{transition:background-color 0.3s ease-in-out;flex-direction:", function(param) {
    var reverseImageAndText = param.reverseImageAndText;
    return reverseImageAndText ? "column-reverse" : "column";
}, ";}.card{top:0;left:0;transition:opacity 0.3s ease-in-out;height:100%;}.card-front-layer{opacity:", function(param) {
    var isFlipped = param.isFlipped;
    return isFlipped ? 0 : 1;
}, ";z-index:", z_index/* LAYER_ONE */.KW, ";}.card-back-layer{height:100%;position:absolute;opacity:", function(param) {
    var isFlipped = param.isFlipped;
    return isFlipped ? 1 : 0;
}, ";z-index:", function(param) {
    var isFlipped = param.isFlipped;
    return isFlipped ? z_index/* LAYER_TWO */.wc : z_index/* HIDDEN */.A1;
}, ";}");

// EXTERNAL MODULE: ./segments/desktop/core-components/grid-paragraph-with-image/grid-paragraph-with-image.js + 2 modules
var grid_paragraph_with_image = __webpack_require__(32627);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/sliding-card-grid/components/sliding-card-grid-base/sliding-card/sliding-card-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var CARD_DEFAULT_PROPS = {
    width: "100%",
    height: "100%",
    titleSize: sizes.XS,
    textSize: sizes.MD
};
var SlidingCardComponent = function(param) {
    var card = param.card, disableCardsHoverStyle = param.disableCardsHoverStyle, fullParagraphAdvancedConfig = param.fullParagraphAdvancedConfig, backgroundHoverColor = param.backgroundHoverColor, borderOpacity = param.borderOpacity, borderColor = param.borderColor, cardColor = param.cardColor, padding = param.padding, sideBySideImage = param.sideBySideImage, reverseImageAndText = param.reverseImageAndText, imageOnTop = param.imageOnTop;
    var ref = (0,react.useState)(false), isHovered = ref[0], setIsHovered = ref[1];
    var backLayer = card === null || card === void 0 ? void 0 : card.backLayer;
    var cardBackgroundColor = (0,react.useMemo)(function() {
        return isHovered && backgroundHoverColor ? backgroundHoverColor : cardColor;
    }, [
        isHovered,
        backgroundHoverColor,
        cardColor
    ]);
    var isBackLayerEnabled = Boolean(backLayer === null || backLayer === void 0 ? void 0 : backLayer.enable);
    var onCardHover = function() {
        setIsHovered(function(isHover) {
            return !isHover;
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSlidingCardComponent, {
        reverseImageAndText: reverseImageAndText,
        padding: padding,
        className: classnames_default()("sliding-card-component", {
            "side-by-side-image": sideBySideImage
        }),
        isFlipped: isBackLayerEnabled && isHovered,
        onMouseEnter: onCardHover,
        onMouseLeave: onCardHover,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("card", "card-front-layer"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_paragraph_with_image/* default */.Z, _object_spread(_object_spread_props(_object_spread({}, card), {
                    disableHoverStyle: disableCardsHoverStyle,
                    fullParagraph: _object_spread({}, fullParagraphAdvancedConfig, card.fullParagraph),
                    borderOpacity: borderOpacity,
                    borderColor: borderColor,
                    cardColor: cardBackgroundColor,
                    padding: padding,
                    imageOnTop: imageOnTop
                }), CARD_DEFAULT_PROPS))
            }),
            isBackLayerEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("card", "card-back-layer"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_paragraph_with_image/* default */.Z, _object_spread(_object_spread_props(_object_spread({}, backLayer), {
                    disableHoverStyle: disableCardsHoverStyle,
                    fullParagraph: _object_spread({}, fullParagraphAdvancedConfig, backLayer.fullParagraph),
                    borderOpacity: borderOpacity,
                    borderColor: borderColor,
                    cardColor: cardColor,
                    padding: padding,
                    imageOnTop: imageOnTop
                }), CARD_DEFAULT_PROPS))
            })
        ]
    });
};
/* harmony default export */ var sliding_card_component = (SlidingCardComponent);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./constants/align-types.js
var align_types = __webpack_require__(79409);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/sliding-card-grid/components/sliding-card-grid-base/carousel-title/carousel-title-component.scss.js




var _obj;
var ARROWS_ALIGNMENT_TO_STYLE = (_obj = {}, (0,src_define_property/* default */.Z)(_obj, align_types.VERTICAL_ALIGN_LABELS.TOP, "flex-start"), (0,src_define_property/* default */.Z)(_obj, align_types.VERTICAL_ALIGN_LABELS.CENTER, "center"), (0,src_define_property/* default */.Z)(_obj, align_types.VERTICAL_ALIGN_LABELS.BOTTOM, "flex-end"), _obj);
var StyledCarouselTitleComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e109bcnz0"
})("	display:flex;justify-content:space-between;align-items:center;margin-bottom:", function(param) {
    var marginBottom = param.marginBottom;
    return marginBottom || 0;
}, ";width:calc(100% / ", function(param) {
    var visibleCards = param.visibleCards;
    return visibleCards || 1;
}, " - ", CARDS_MARGIN, ");", function(param) {
    var arrowsAlignment = param.arrowsAlignment;
    return arrowsAlignment && "align-items: ".concat(ARROWS_ALIGNMENT_TO_STYLE[arrowsAlignment], ";");
}, "	\n	.carousel-arrow-wrapper{display:flex;justify-content:center;gap:12px;.carousel-arrow{cursor:pointer;svg{height:40px;width:40px;}}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title_title = __webpack_require__(91265);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/sliding-card-grid/components/sliding-card-grid-base/carousel-title/title-prev-carousel-arrow.js

var TitlePrevCarouselArrow = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "57",
        height: "57",
        viewBox: "0 0 57 57",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "28.5",
                cy: "28.5",
                r: "28",
                stroke: color || "#DCDFEC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.2929 28.7071C13.9024 28.3166 13.9024 27.6834 14.2929 27.2929L20.6569 20.9289C21.0474 20.5384 21.6805 20.5384 22.0711 20.9289C22.4616 21.3195 22.4616 21.9526 22.0711 22.3431L16.4142 28L22.0711 33.6569C22.4616 34.0474 22.4616 34.6805 22.0711 35.0711C21.6805 35.4616 21.0474 35.4616 20.6569 35.0711L14.2929 28.7071ZM41 29H15V27H41V29Z",
                fill: color || "white"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/sliding-card-grid/components/sliding-card-grid-base/carousel-title/title-next-carousel-arrow.js

var TitleNextCarouselArrow = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "57",
        height: "57",
        viewBox: "0 0 57 57",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "28.5",
                cy: "28.5",
                r: "28",
                stroke: color || "#DCDFEC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M42.2071 29.2071C42.5976 28.8166 42.5976 28.1834 42.2071 27.7929L35.8431 21.4289C35.4526 21.0384 34.8195 21.0384 34.4289 21.4289C34.0384 21.8195 34.0384 22.4526 34.4289 22.8431L40.0858 28.5L34.4289 34.1569C34.0384 34.5474 34.0384 35.1805 34.4289 35.5711C34.8195 35.9616 35.4526 35.9616 35.8431 35.5711L42.2071 29.2071ZM15.5 29.5H41.5V27.5H15.5V29.5Z",
                fill: color || "white"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/sliding-card-grid/components/sliding-card-grid-base/carousel-title/carousel-title-component.js
function carousel_title_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function carousel_title_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            carousel_title_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var CarouselTitleComponent = function(param) {
    var title = param.title, onPrevClick = param.onPrevClick, onNextClick = param.onNextClick, visibleCards = param.visibleCards, setIsPaused = param.setIsPaused;
    var _ref = title || {}, withArrows = _ref.withArrows, marginBottom = _ref.marginBottom, arrowsAlignment = _ref.arrowsAlignment, arrowColor = _ref.arrowColor, titleConfig = _object_without_properties(_ref, [
        "withArrows",
        "marginBottom",
        "arrowsAlignment",
        "arrowColor"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCarouselTitleComponent, {
        arrowsAlignment: arrowsAlignment,
        visibleCards: visibleCards,
        marginBottom: marginBottom,
        className: "carousel-title-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(title_title/* default */.Z, carousel_title_component_object_spread({}, titleConfig)),
            withArrows && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "carousel-arrow-wrapper",
                onMouseEnter: function() {
                    return setIsPaused(true);
                },
                onMouseLeave: function() {
                    return setIsPaused(false);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "carousel-arrow",
                        onClick: onPrevClick,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TitlePrevCarouselArrow, {
                            color: arrowColor
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "carousel-arrow",
                        onClick: onNextClick,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleNextCarouselArrow, {
                            color: arrowColor
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var carousel_title_component = (CarouselTitleComponent);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/sliding-card-grid/consts.js
var ARROW_DESIGN_TYPE = {
    ARROWS_ON_BOTTOM_MIDDLE: "arrows-on-bottom-middle",
    ARROWS_ON_TOP_RIGHT: "arrows-on-top-right"
};

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/sliding-card-grid/components/sliding-card-grid-base/TopRightPrevArrow.js


var TopRightPrevArrow = function(param) {
    var onClick = param.onClick, isDisabled = param.isDisabled, _color = param.color, color = _color === void 0 ? "white" : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        type: "button",
        className: "carousel-arrow-wrapper prev",
        onClick: onClick,
        tabIndex: 0,
        disabled: isDisabled,
        style: {
            background: "transparent",
            border: "none",
            boxShadow: "none",
            padding: 0
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "62",
            height: "62",
            viewBox: "0 0 62 62",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    cx: "31",
                    cy: "31",
                    r: "30.5",
                    fill: "transparent",
                    stroke: color
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M18.2929 30.2929C17.9024 30.6834 17.9024 31.3166 18.2929 31.7071L24.6569 38.0711C25.0474 38.4616 25.6805 38.4616 26.0711 38.0711C26.4616 37.6805 26.4616 37.0474 26.0711 36.6569L20.4142 31L26.0711 25.3431C26.4616 24.9526 26.4616 24.3195 26.0711 23.9289C25.6805 23.5384 25.0474 23.5384 24.6569 23.9289L18.2929 30.2929ZM43 30L19 30V32H43V30Z",
                    fill: color
                })
            ]
        })
    });
};
/* harmony default export */ var sliding_card_grid_base_TopRightPrevArrow = (TopRightPrevArrow);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/sliding-card-grid/components/sliding-card-grid-base/TopRightNextArrow.js


var TopRightNextArrow = function(param) {
    var onClick = param.onClick, isDisabled = param.isDisabled, _color = param.color, color = _color === void 0 ? "white" : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        type: "button",
        className: "carousel-arrow-wrapper next",
        onClick: onClick,
        tabIndex: 0,
        disabled: isDisabled,
        style: {
            background: "transparent",
            border: "none",
            boxShadow: "none",
            padding: 0
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "62",
            height: "62",
            viewBox: "0 0 62 62",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    cx: "31",
                    cy: "31",
                    r: "30.5",
                    transform: "matrix(-1 0 0 1 62 0)",
                    fill: "transparent",
                    stroke: color
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M43.7071 30.2929C44.0976 30.6834 44.0976 31.3166 43.7071 31.7071L37.3431 38.0711C36.9526 38.4616 36.3195 38.4616 35.9289 38.0711C35.5384 37.6805 35.5384 37.0474 35.9289 36.6569L41.5858 31L35.9289 25.3431C35.5384 24.9526 35.5384 24.3195 35.9289 23.9289C36.3195 23.5384 36.9526 23.5384 37.3431 23.9289L43.7071 30.2929ZM19 30L43 30V32H19V30Z",
                    fill: color
                })
            ]
        })
    });
};
/* harmony default export */ var sliding_card_grid_base_TopRightNextArrow = (TopRightNextArrow);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/sliding-card-grid/components/sliding-card-grid-base/TopRightArrowsGroup.js




var TopRightArrowsGroup = function(param) {
    var onPrev = param.onPrev, onNext = param.onNext, topOffset = param.topOffset, arrowColor = param.arrowColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "carousel-arrows-edge-group",
        style: {
            top: topOffset
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sliding_card_grid_base_TopRightPrevArrow, {
                onClick: onPrev,
                color: arrowColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sliding_card_grid_base_TopRightNextArrow, {
                onClick: onNext,
                color: arrowColor
            })
        ]
    });
};
/* harmony default export */ var sliding_card_grid_base_TopRightArrowsGroup = (TopRightArrowsGroup);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/sliding-card-grid/components/sliding-card-grid-base/sliding-card-grid-base-component.js
function sliding_card_grid_base_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function sliding_card_grid_base_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            sliding_card_grid_base_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function sliding_card_grid_base_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function sliding_card_grid_base_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        sliding_card_grid_base_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}















var SlidingCardGridBaseComponent = function(param) {
    var cards = param.cards, cardsToShow = param.cardsToShow, cardColor = param.cardColor, cardInnerPadding = param.cardInnerPadding, borderColor = param.borderColor, backgroundHoverColor = param.backgroundHoverColor, borderOpacity = param.borderOpacity, arrowsColor = param.arrowsColor, isFullScreen = param.isFullScreen, fullParagraphAdvancedConfig = param.fullParagraphAdvancedConfig, desktopHorizontalPadding = param.desktopHorizontalPadding, desktopHorizontalPaddingSmallScreens = param.desktopHorizontalPaddingSmallScreens, disableCardsHoverStyle = param.disableCardsHoverStyle, slideBreakingPoints = param.slideBreakingPoints, focusOnSelect = param.focusOnSelect, sideBySideImage = param.sideBySideImage, carouselTitle = param.carouselTitle, removeArrows = param.removeArrows, carouselTitleAdvancedConfig = param.carouselTitleAdvancedConfig, desktopVerticalPadding = param.desktopVerticalPadding, reverseImageAndText = param.reverseImageAndText, cardBorderRadius = param.cardBorderRadius, cardImageSize = param.cardImageSize, cardImageRadius = param.cardImageRadius, customItemRenderer = param.customItemRenderer, autoplay = param.autoplay, autoplaySpeed = param.autoplaySpeed, _infinite = param.infinite, infinite = _infinite === void 0 ? false : _infinite, isInView = param.isInView, imageOnTop = param.imageOnTop, arrowDesignType = param.arrowDesignType, arrowsTopOffset = param.arrowsTopOffset, topRightArrowColor = param.topRightArrowColor;
    var slider = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), isFirstTimeVisible = ref[0], setIsFirstTimeVisible = ref[1];
    var ref1 = (0,react.useState)(false), isPaused = ref1[0], setIsPaused = ref1[1];
    var slideResponsive = (0,react.useMemo)(function() {
        return slideBreakingPoints === null || slideBreakingPoints === void 0 ? void 0 : slideBreakingPoints.map(function(param) {
            var breakpoint = param.breakpoint, slidesToShow = param.slidesToShow;
            return {
                breakpoint: parseInt(breakpoint),
                settings: {
                    slidesToShow: parseFloat(slidesToShow)
                }
            };
        });
    }, [
        slideBreakingPoints
    ]);
    var itemRenderer = function(card) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(sliding_card_component, {
            card: card,
            sideBySideImage: sideBySideImage,
            disableHoverStyle: disableCardsHoverStyle,
            fullParagraphAdvancedConfig: fullParagraphAdvancedConfig,
            borderOpacity: borderOpacity,
            borderColor: borderColor,
            backgroundHoverColor: backgroundHoverColor,
            cardColor: cardColor,
            padding: cardInnerPadding,
            reverseImageAndText: reverseImageAndText,
            imageOnTop: imageOnTop
        });
    };
    (0,react.useEffect)(function() {
        if (isInView && !isFirstTimeVisible) {
            setIsFirstTimeVisible(true);
        }
    }, [
        isInView,
        isFirstTimeVisible
    ]);
    (0,react.useEffect)(function() {
        if (autoplay) {
            if (isPaused) {
                var _slider_current;
                (_slider_current = slider.current) === null || _slider_current === void 0 ? void 0 : _slider_current.pause();
            } else {
                var _slider_current1;
                (_slider_current1 = slider.current) === null || _slider_current1 === void 0 ? void 0 : _slider_current1.play();
            }
        }
    }, [
        isPaused
    ]);
    var areCardsToShowUnevenNumber = (0,react.useMemo)(function() {
        return Number(cardsToShow) < cards.length && !Number.isInteger(Number(cardsToShow));
    }, [
        cards.length,
        cardsToShow
    ]);
    var PrevArrow = function(param) {
        var className = param.className, onClick = param.onClick;
        var onPrevArrowClick = function() {
            if (onClick) {
                (0,bigbrain_service.trackEvent)(bigbrain_event_types.CAROUSEL_ARROW_CLICKED, {
                    info3: "prev"
                });
                onClick();
            }
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            type: "button",
            className: classnames_default()(className, "carousel-arrow-wrapper", "prev"),
            onClick: onPrevArrowClick,
            tabIndex: 0,
            onKeyDown: (0,accessibility_service/* generateOnKeyDownHandler */.vR)(onClick),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(prev_carousel_arrow, {
                isDisabled: !onClick,
                color: colors/* default */.Z[arrowsColor]
            })
        });
    };
    var NextArrow = function(param) {
        var className = param.className, onClick = param.onClick;
        var onNextArrowClick = function() {
            if (onClick) {
                (0,bigbrain_service.trackEvent)(bigbrain_event_types.CAROUSEL_ARROW_CLICKED, {
                    info3: "next"
                });
                onClick();
            }
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            type: "button",
            className: classnames_default()(className, "carousel-arrow-wrapper", "next"),
            onClick: onNextArrowClick,
            tabIndex: 0,
            onKeyDown: (0,accessibility_service/* generateOnKeyDownHandler */.vR)(onClick),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_carousel_arrow, {
                isDisabled: !onClick,
                color: colors/* default */.Z[arrowsColor]
            })
        });
    };
    var carouselProps = {
        items: cards,
        focusOnSelect: focusOnSelect,
        itemRenderer: customItemRenderer || itemRenderer,
        defaultIndex: 0,
        infinite: infinite,
        centerMode: false,
        slidesToShow: Number(cardsToShow) || undefined,
        centerPadding: "15%",
        arrows: !removeArrows,
        swipeToSlide: true,
        autoplay: isFirstTimeVisible && autoplay,
        autoplaySpeed: autoplaySpeed
    };
    // Don't show arrows in carousel if arrows are on top right
    if (arrowDesignType !== ARROW_DESIGN_TYPE.ARROWS_ON_TOP_RIGHT) {
        carouselProps.prevArrow = /*#__PURE__*/ (0,jsx_runtime.jsx)(PrevArrow, {});
        carouselProps.nextArrow = /*#__PURE__*/ (0,jsx_runtime.jsx)(NextArrow, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSlidingCardGridBaseComponent, {
        cardBorderRadius: cardBorderRadius,
        cardImageSize: cardImageSize,
        cardImageRadius: cardImageRadius,
        desktopHorizontalPadding: desktopHorizontalPadding,
        desktopHorizontalPaddingSmallScreens: desktopHorizontalPaddingSmallScreens,
        desktopVerticalPadding: desktopVerticalPadding,
        arrowsTopOffset: arrowsTopOffset,
        className: classnames_default()("sliding-card-grid-component", {
            "full-carousel-width": areCardsToShowUnevenNumber,
            "full-screen": isFullScreen,
            "disable-hover-effect": disableCardsHoverStyle,
            "with-title": !!(carouselTitle === null || carouselTitle === void 0 ? void 0 : carouselTitle.title),
            "infinite-mode": infinite,
            "edge-arrows": arrowDesignType === ARROW_DESIGN_TYPE.ARROWS_ON_TOP_RIGHT
        }),
        children: [
            arrowDesignType === ARROW_DESIGN_TYPE.ARROWS_ON_TOP_RIGHT && /*#__PURE__*/ (0,jsx_runtime.jsx)(sliding_card_grid_base_TopRightArrowsGroup, {
                onPrev: function() {
                    var _slider_current;
                    return (_slider_current = slider.current) === null || _slider_current === void 0 ? void 0 : _slider_current.prev();
                },
                onNext: function() {
                    var _slider_current;
                    return (_slider_current = slider.current) === null || _slider_current === void 0 ? void 0 : _slider_current.next();
                },
                topOffset: arrowsTopOffset,
                arrowColor: colors/* default */.Z[topRightArrowColor]
            }),
            (carouselTitle === null || carouselTitle === void 0 ? void 0 : carouselTitle.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel_title_component, {
                visibleCards: cardsToShow,
                title: sliding_card_grid_base_component_object_spread({}, carouselTitle, carouselTitleAdvancedConfig),
                onPrevClick: function() {
                    var _slider_current;
                    return slider === null || slider === void 0 ? void 0 : (_slider_current = slider.current) === null || _slider_current === void 0 ? void 0 : _slider_current.prev();
                },
                onNextClick: function() {
                    var _slider_current;
                    return slider === null || slider === void 0 ? void 0 : (_slider_current = slider.current) === null || _slider_current === void 0 ? void 0 : _slider_current.next();
                },
                setIsPaused: setIsPaused
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* default */.Z, sliding_card_grid_base_component_object_spread_props(sliding_card_grid_base_component_object_spread({
                ref: slider
            }, carouselProps), {
                responsive: slideResponsive
            }))
        ]
    });
};
/* harmony default export */ var sliding_card_grid_base_component = (SlidingCardGridBaseComponent);


/***/ })

}]);